import React from "react"
import { Button, Input, Spin, Typography } from "antd"
import { useLoginMutation } from "../../generated-types"
import { useLoginContext } from "../../components/context/LoginContext"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { handleGqlError } from "../../utils/utils"
import { useTranslation } from "react-i18next"
import SelectLanguage from "../../components/SelectLanguage"

export default () => {
  const { login, isLogined } = useLoginContext()
  const { t } = useTranslation()
  const [email, setEmail] = React.useState("")
  const [passwd, setPasswd] = React.useState("")
  const [doLogin, { data, loading }] = useLoginMutation({
    fetchPolicy: "no-cache",
    onError: (e) => handleGqlError(e, (msg) => toast(msg, { type: "error" })),
  })
  const navigate = useNavigate()

  React.useEffect(() => {
    if (isLogined) {
      navigate("/view", { replace: true })
    }
  }, [isLogined, navigate])

  React.useEffect(() => {
    if (data) {
      login(data.managerLogin)
      navigate("/view")
    }
  }, [data])

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#00739D" }}>
      <div>
        <form onSubmit={(e) => { e.preventDefault(); doLogin({ variables: { email, passwd } }) }}>
          <div style={{ background: "white", borderRadius: "12px", padding: "24px", width: "400px", display: "flex", flexDirection: "column", gap: "12px" }}>
            <Typography.Title level={2} style={{ textAlign: "center", margin: "8px 0" }}>
              DINO Manager
            </Typography.Title>
            <Input
              placeholder={t("session.key.Email.word")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              size="large"
              style={{ height: 44 }}
            />
            <Input
              placeholder={t("login.password.word")}
              value={passwd}
              onChange={(e) => setPasswd(e.target.value)}
              required
              type="password"
              disabled={loading}
              size="large"
              style={{ height: 44 }}
            />
            <div style={{ position: "relative" }}>
              <Button type="primary" htmlType="submit" block disabled={loading} style={{ height: 44 }}>
                {t("login.sign-in.word")}
              </Button>
              {loading && (
                <Spin style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
              )}
            </div>
            <Button block disabled={loading} onClick={() => navigate("/forgot_passwd")} style={{ height: 44 }}>
              {t("login.forgot-password.word")}
            </Button>
          </div>
        </form>
        <div style={{ marginTop: "15px", textAlign: "center" }}>
          <SelectLanguage style={{ color: "#FFFFFF" }} />
        </div>
      </div>
    </div>
  )
}
